import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService } from "../data.service";
import { parse, format, AsYouType } from "libphonenumber-js";
import { EventsService } from "angular4-events";
declare var Nanobar: any;

declare var $: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: "app-business-category",
  templateUrl: "./business-category.component.html",
  styleUrls: ["./business-category.component.css"],
})
export class BusinessCategoryComponent implements OnInit, OnDestroy {
  nao = new Nanobar();
  error_count: any;
  catImage = "";
  catImageEdit = "";
  isDisabled = false;
  bcName = "";
  bcNameMob = "";
  addbCatSuccess: any;
  bcatData: any;
  editId: any;
  bcNameEdit = "";
  bcNameMobEdit = "";
  editSuccess: any;
  editMsg: any;
  isWeb: any;
  isMobile: any;
  isTrackDriver: any;
  isFeatured: any;
  isFeaturedHome: any;
  isCity: any;
  settingSuccess: any;
  settingData: any;
  prescriptionSetting: any;
  settingSuccess2: any;
  verifyId: any;
  catImageChkOnEdit: any;
  disableClick: any;
  options: any;
  tileImage: any;
  tileImageEdit = null;
  editimgChk: any;
  backgroundColor: any="#ffffff";
  outlineColor: any="#ffffff";
  constructor(private dataService: DataService, private pubsub: EventsService) {
    this.dataService.pageName = "Category listing";
    if (window.localStorage.getItem("isauthenticated") !== "true") {
      window.location.href = "/";
    }
    this.options = {
      onUpdate: (event: any) => {
        this.editCategoryListing();
      },
    };
  }
  editCategoryListing() {
    var is_category = true;
    this.dataService
      .sortBusinessCategory(
        window.localStorage.getItem("token"),
        this.bcatData,
        is_category
      )
      .subscribe(
        (data) => {},
        (error) => {}
      );
  }
  getbusinessCategoryFunction() {
    this.nao.go(30);
    this.dataService
      .getBusinessCategory(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.bcatData = [];
          this.bcatData = data;
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  uploadCategory() {
    $("#addBCatPop").modal("show");
    $(".uploadText").css("color", "#3d3e3d");
    $(".uploadTextTile").css("color", "#3d3e3d");
    this.catImage = undefined;
    this.tileImage = undefined;
  }
  addbCategory() {
    this.disableClick = true;
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".uploadTextTile").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    // this.catImage = $('#image-cropper2').cropit('export');
    if (this.catImage === undefined) {
      $(".uploadText").css("color", "#a10a0d");
      this.error_count++;
    }
    if (this.tileImage === undefined) {
      $(".uploadTextTile").css("color", "#a10a0d");
      this.error_count++;
    }
    if (this.bcName === "" || this.bcName === undefined) {
      $("#bcat-name label").css("color", "#a10a0d");
      $("#bcat-name input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.bcNameMob === "" || this.bcNameMob === undefined) {
      $("#bcat-name label").css("color", "#a10a0d");
      $("#bcat-name input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (!this.backgroundColor) {
      $("#background-picker label").css("color", "#a10a0d");
      $("#background-picker input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (!this.outlineColor) {
      $("#outline-picker label").css("color", "#a10a0d");
      $("#outline-picker input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.error_count > 0) {
      this.disableClick = false;
      return;
    }
    this.nao.go(30);
    this.dataService
      .addBusinessCategory(
        window.localStorage.getItem("token"),
        this.bcName,
        this.bcNameMob,
        this.catImage,
        this.tileImage,
        this.backgroundColor,
        this.outlineColor
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.addbCatSuccess = data;
          this.addbCatSuccess = this.addbCatSuccess.success;
          if (this.addbCatSuccess === true) {
            this.getbusinessCategoryFunction();
            this.disableClick = false;
            $("#addBCatPop").modal("hide");
          }
        },
        (error) => {
          this.nao.go(100);
          this.disableClick = false;
        }
      );
  }
  backgroundColorEdit: string;
  outlineColorEdit: string;
  editCategoryPop(catObj) {
    this.bcNameEdit = catObj.name;
    this.bcNameMobEdit = catObj.splash_name;
    this.editId = catObj.id;
    this.catImageEdit = catObj.image;
    this.catImageChkOnEdit = catObj.image;
    this.backgroundColorEdit = catObj.background_hexadecimal;
    this.outlineColorEdit = catObj.border_hexadecimal;

    this.tileImageEdit = catObj.category_tile_image;
    this.editimgChk = catObj.category_tile_image;
    $("#editBCatPop").modal("show");
  }

  toggleSet(data, id) {
    if (this.isDisabled) {
      return;
    } else {
      this.businessSettingsFunction(data, id);
    }
  }

  editBCategory() {
    this.disableClick = true;
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    // $('.uploadTextEdit').css('color', '#3d3e3d');
    $(".c-label input").css("border-color", "#ccc");
    if (this.catImageEdit === this.catImageChkOnEdit) {
      this.catImageEdit = null;
      // $('.uploadTextEdit').css('color', '#a10a0d');
      // this.error_count ++;
    }
    if (this.bcNameEdit === "" || this.bcNameEdit === undefined) {
      $("#bcat-nameEdit label").css("color", "#a10a0d");
      $("#bcat-nameEdit input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.bcNameMobEdit === "" || this.bcNameMobEdit === undefined) {
      $("#bcat-nameEdit label").css("color", "#a10a0d");
      $("#bcat-nameEdit input").css("border-color", "#a10a0d");
      this.error_count++;
    }

    var cityImg = this.tileImageEdit;
    if (this.tileImageEdit === this.editimgChk) {
      cityImg = null;
      // this.error_count ++;
    }

    if (!this.backgroundColorEdit) {
      $("#background-picker-edit label").css("color", "#a10a0d");
      $("#background-picker-edit input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (!this.outlineColorEdit) {
      $("#outline-picker-edit label").css("color", "#a10a0d");
      $("#outline-picker-edit input").css("border-color", "#a10a0d");
      this.error_count++;
    }

    if (this.error_count > 0) {
      this.disableClick = false;
      return;
    }
    this.nao.go(30);
    this.dataService
      .editBusinessCategory(
        window.localStorage.getItem("token"),
        this.editId,
        this.bcNameEdit,
        this.bcNameMobEdit,
        this.catImageEdit,
        cityImg,
        this.backgroundColorEdit,
        this.outlineColorEdit
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.editSuccess = data;
          this.editMsg = this.editSuccess.message;
          this.editSuccess = this.editSuccess.success;
          if (this.editSuccess === true) {
            this.getbusinessCategoryFunction();
            this.disableClick = false;
            $("#editBCatPop").modal("hide");
            toastr.success(this.editMsg);
          }
        },
        (error) => {
          this.nao.go(100);
          this.disableClick = false;
        }
      );
  }
  businessSettingsFunction(data, index) {
    this.nao.go(30);
    if ($("#isMob" + index).prop("checked") === true) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    if ($("#isWeb" + index).prop("checked") === true) {
      this.isWeb = true;
    } else {
      this.isWeb = false;
    }
    if ($("#feature" + index).prop("checked") === true) {
      data.is_featured = true;
      this.isDisabled = false;
      this.isFeatured = true;
      if ($("#featureHome" + index).prop("checked") === true) {
        this.isFeaturedHome = true;
      } else {
        this.isFeaturedHome = false;
      }
    } else {
      this.isDisabled = true;
      data.is_featured = false;
      data.is_featured_on_mobile = false;
      this.isFeatured = false;
      this.isFeaturedHome = false;
    }
    this.dataService
      .businessSettings(
        window.localStorage.getItem("token"),
        data.id,
        this.isMobile,
        this.isWeb,
        this.isFeatured,
        this.isFeaturedHome
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.settingSuccess = data;
          this.settingSuccess = this.settingSuccess.success;
          if (this.settingSuccess === true) {
            toastr.success("Settings Updated Successfully");
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  driverLocationFunction(id, index) {
    this.nao.go(30);
    if ($("#isdriverLoc" + index).prop("checked") === true) {
      this.isTrackDriver = true;
    } else {
      this.isTrackDriver = false;
    }
    this.dataService
      .driverLocationFunSeeting(
        window.localStorage.getItem("token"),
        id,
        this.isTrackDriver
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.settingSuccess = data;
          this.settingSuccess = this.settingSuccess.success;
          if (this.settingSuccess === true) {
            toastr.success("Settings Updated Successfully");
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  businessCitySettingsFunction(cityId, index, business_cat_id) {
    this.nao.go(30);
    if ($("#is_show" + index).prop("checked") === true) {
      this.isCity = true;
    } else {
      this.isCity = false;
    }
    this.dataService
      .businessCitySettings(
        window.localStorage.getItem("token"),
        cityId,
        business_cat_id,
        this.isCity
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.settingSuccess = data;
          this.settingSuccess = this.settingSuccess.success;
          if (this.settingSuccess === true) {
            toastr.success("Settings Updated Successfully");
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  // chkFeatured(id, index) {
  // if ($('#feature' + index).prop('checked') === true) {

  //   this.featuredCategoryFuntion(id);
  // }
  // }
  // getSettingsFunction () {
  //   this.nao.go(30);
  //   this.dataService.getPrescriptionSettings(window.localStorage.getItem('token')).subscribe(
  //     (data) => {
  //       this.nao.go(100);
  //       this.settingData = data;
  //     },
  //     (error) => {
  //       this.nao.go(100);
  //     }
  //   );
  // }
  updatePrescriptionSettingsFunction(id, index) {
    this.nao.go(30);
    if ($("#dStepPrescription" + index).prop("checked") === true) {
      this.prescriptionSetting = true;
    } else {
      this.prescriptionSetting = false;
    }
    if ($("#dStepVerify" + index).prop("checked") === true) {
      this.verifyId = true;
    } else {
      this.verifyId = false;
    }
    this.dataService
      .updatePrescriptionSettings(
        window.localStorage.getItem("token"),
        id,
        this.prescriptionSetting,
        this.verifyId
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.settingSuccess2 = data;
          this.settingSuccess2 = this.settingSuccess2.success;
          if (this.settingSuccess2 === true) {
            toastr.success("Settings Updated Successfully");
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  clearBusinessImage() {
    $(".cropit-image-input").val("");
  }
  expotyBanner() {
    $(".cropit-image-input").val("");
    this.catImage = $(".image-cropper").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    $("#cropperBannerImgPop").modal("hide");
  }
  clearLogoImage() {
    $(".cropit-image-input2").val("");
  }
  expotyProfile() {
    $(".cropit-image-input2").val("");
    this.catImageEdit = $(".image-cropper2").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    $("#cropperProfileImgPop").modal("hide");
  }

  clearTileImage() {
    $(".cropit-image-input-tile").val("");
  }
  expotyTile() {
    $(".cropit-image-input-tile").val("");
    this.tileImage = $(".image-cropper-tile").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    $("#cropperTileImgPop").modal("hide");
  }

  clearTileImageEdit() {
    $(".cropit-image-input-tile-edit").val("");
  }
  expotyTileEdit() {
    $(".cropit-image-input-tile-edit").val("");
    this.tileImageEdit = $(".image-cropper-tile-edit").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    $("#cropperTileImgPopEdit").modal("hide");
  }

  categoriesPopupOpen() {
    $("#categoriesPopup").modal("show");
  }
  ngOnInit() {
    this.getbusinessCategoryFunction();
    // $('.select-image-btn').click(function() {
    //   $('.cropit-image-input').click();
    // });
    // $('#image-cropper').cropit({
    //   $preview: $('.cropit-preview'),
    //   allowDragNDrop: true,
    // });
    setTimeout(() => {
      $(".image-cropper").cropit({
        $preview: $(".cropit-preview"),
        $zoomSlider: $(".cropit-image-zoom-input-banner"),
        allowDragNDrop: true,
        minZoom: "fill",
        initialZoom: "min",
        originalSize: true,
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: "allow",
        // freeMove: true
      });
    }, 1500);
    $("#cropit-image-input").change(function () {
      if ($(".cropit-image-input").val() !== "") {
        $("#cropperBannerImgPop").modal("show");
      }
    });
    $(".select-image-btn").click(function () {
      $("#cropit-image-input").click();
    });
    setTimeout(() => {
      $(".image-cropper2").cropit({
        $preview: $(".cropit-preview2"),
        $fileInput: $(".cropit-image-input2"),
        $zoomSlider: $(".cropit-image-zoom-input-logo"),
        allowDragNDrop: true,
        minZoom: "fill",
        initialZoom: "min",
        originalSize: true,
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: "allow",
      });
    }, 1500);
    $("#cropit-image-input2").change(function () {
      if ($(".cropit-image-input2").val() !== "") {
        $("#cropperProfileImgPop").modal("show");
      }
    });
    $(".select-image-btn2").click(function () {
      $("#cropit-image-input2").click();
    });

    setTimeout(() => {
      $(".image-cropper-tile").cropit({
        $preview: $(".cropit-preview-tile"),
        $fileInput: $(".cropit-image-input-tile"),
        $zoomSlider: $(".cropit-image-zoom-input-tile"),
        allowDragNDrop: true,
        minZoom: "fill",
        initialZoom: "min",
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: "allow",
      });
    }, 1500);
    $("#cropit-image-input-tile").change(function () {
      if ($(".cropit-image-input-tile").val() !== "") {
        $("#cropperTileImgPop").modal("show");
      }
    });
    $(".select-image-btn-tile").click(function () {
      $("#cropit-image-input-tile").click();
    });

    setTimeout(() => {
      $(".image-cropper-tile-edit").cropit({
        $preview: $(".cropit-preview-tile-edit"),
        $fileInput: $(".cropit-image-input-tile-edit"),
        $zoomSlider: $(".cropit-image-zoom-input-tile-edit"),
        allowDragNDrop: true,
        minZoom: "fill",
        initialZoom: "min",
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: "allow",
      });
    }, 1500);
    $("#cropit-image-input-tile-edit").change(function () {
      if ($(".cropit-image-input-tile-edit").val() !== "") {
        $("#cropperTileImgPopEdit").modal("show");
      }
    });
    $(".select-image-btn-tile-edit").click(function () {
      $("#cropit-image-input-tile-edit").click();
    });
    $('#cropperProfileImgPop').on('hidden.bs.modal', function () {
      $('body').addClass('modal-open');
    });

    $('#cropperTileImgPop').on('hidden.bs.modal', function () {
      $('body').addClass('modal-open');
    });
    
    // $('#image-cropper2').cropit({
    //   $preview: $('.cropit-preview2'),
    //   $fileInput: $('.cropit-image-input2'),
    //   allowDragNDrop: true,
    //   // minZoom: 'fit',
    //   // maxZoom: 20,
    //   // imageBackground: false,
    //   // imageBackgroundBorderWidth: 30
    // });
    // $('.select-image-btn2').click(function() {
    //   $('.cropit-image-input2').click();
    // });
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#bcategories").css("color", "#d77229");
  }
  ngOnDestroy() {
    // this.editCategoryListing();
  }

  log() {}
}



// WEBPACK FOOTER //
// ./src/app/business-category/business-category.component.ts